(function () {
  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value);
    }

    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = value;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();

      try {
        if (!document.execCommand('copy')) {
          throw new Error('Copy command failed');
        }
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(field);
      }
    });
  }

  function initializeSharing(root) {
    (root || document).querySelectorAll('[data-hb-product-sharing]').forEach(function (sharing) {
      if (sharing.dataset.hbSharingReady === 'true') return;
      sharing.dataset.hbSharingReady = 'true';

      var title = sharing.dataset.shareTitle;
      var url = sharing.dataset.shareUrl;
      var nativeButton = sharing.querySelector('.hb-product-sharing__native');
      var copyButton = sharing.querySelector('.hb-product-sharing__copy');
      var copyLabel = sharing.querySelector('.hb-product-sharing__copy-label');
      var status = sharing.querySelector('[data-hb-share-status]');
      var resetTimer;

      if (nativeButton && typeof navigator.share === 'function') {
        nativeButton.hidden = false;
        nativeButton.addEventListener('click', function () {
          navigator.share({ title: title, url: url }).catch(function (error) {
            if (error && error.name !== 'AbortError') {
              console.warn('Product sharing failed', error);
            }
          });
        });
      }

      if (copyButton) {
        copyButton.addEventListener('click', function () {
          copyText(url).then(function () {
            window.clearTimeout(resetTimer);
            copyButton.classList.add('is-copied');
            copyLabel.textContent = copyButton.dataset.copiedLabel;
            status.textContent = copyButton.dataset.copiedLabel;
            resetTimer = window.setTimeout(function () {
              copyButton.classList.remove('is-copied');
              copyLabel.textContent = copyButton.dataset.copyLabel;
              status.textContent = '';
            }, 2000);
          }).catch(function (error) {
            console.warn('Copy link failed', error);
          });
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeSharing(document);
    });
  } else {
    initializeSharing(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeSharing(event.target);
  });
})();
